import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const totalSum=campagneData.stats.total.sum.total
    const total=campagneData.stats.total.sum.total/partnerMontant


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    const displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor=campagneData.config?.secondaryColor || "#000"

    let donorName=campagneData.config?.donorName || "Parrainages"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })
    const formater2=new Intl.NumberFormat('de-DE', { style:"currency",maximumFractionDigits:0,currency:"EUR" })


    let totalFeuilles=parseInt(campagneData?.counters.find(i=>i.label === "feuilles")?.nb) || 0
    let totalSponsor=parseInt(campagneData?.counters.find(i=>i.label === "sponsor")?.nb) || 0
    let totalArt=parseInt(campagneData?.counters.find(i=>i.label === "art")?.nb) || 0
    let totalClasse=parseInt(campagneData?.counters.find(i=>i.label === "classe")?.nb) || 0


    return (
        <>
            <div style={{
                position: "absolute",
                top: "20vh",
                left: "36vw",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width:"30vw",
                gap:50,
                border:"0px solid red"
            }}>
                <span style={{
                    textAlign: "center",
                    color: "#FFF",
                    fontWeight: "500",
                    fontSize: 270,
                    letterSpacing: -8
                }}>{parseInt(total)}</span>

                <div style={{display:"flex",flexDirection:"column",alignItems:"start",gap:10,paddingTop:30}}>
                     <span style={{
                         textAlign: "center",
                         color: "#FFF",
                         fontWeight: "300",
                         fontSize: 100,
                         marginTop: -60
                     }}>enfants</span>

                    <span style={{
                        textAlign: "center",
                        color: "#FFF",
                        fontWeight: "300",
                        fontSize: 100,
                        marginTop: -60
                    }}>parrainés</span>
                </div>

            </div>


            <div style={{position: "absolute", bottom: "5vh", left: 0}}>
                <div className={"d-flex align-items-center"}
                     style={{gap: 35, justifyContent: "center", width: "100vw"}}>

                    <span style={{
                        textAlign: "center",
                        textTransform: "uppercase",
                        color: "#FFF",
                        fontSize: 30,
                        letterSpacing: 10
                    }}>Objectif atteint</span>

                    <div style={{padding: 6, border: "2px solid rgb(103,223,232)"}}>
                        <ProgressBar
                            customLabel={<span/>}
                            animateOnRender
                            completed={percent}
                            width={"40vw"}
                            height={"2.5vh"}
                            borderRadius={5}
                            bgColor={"rgb(103,223,232)"}
                            baseBgColor={"rgba(26,56,65)"}

                        />
                    </div>


                    <span style={{
                        textAlign: "center",
                        color: "rgb(103,223,232)",
                        fontWeight: "600",
                        fontSize: 50
                    }}>{parseInt(percent)}%</span>


                    <span style={{
                        padding: "0 30px",
                        backgroundColor: "rgb(103,223,232)",
                        color: 'rgba(26,56,65)',
                        fontSize: 40,
                        textTransform: "uppercase",
                        fontWeight: "700"
                    }}>{parseInt(total)} DONS</span>

                </div>
            </div>


        </>
    )
}


/*

<div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 10}}>

                <div>
                    <span className={"screen-count-text2"}><Counter number={total} decimals={0} preserveValue/> {donorName}</span>
                </div>


                <ProgressBar
                    customLabel={<span style={{fontSize:"3.5vh",marginRight:"1vw"}}><Counter number={displayPercent} decimals={0}/>%</span>}
                    animateOnRender
                    completed={percent >= 10 ? percent : 10}
                    width={"70vw"}
                    height={"7vh"}
                    bgColor={"linear-gradient(90deg, rgba(220,171,107,1) 30%, rgba(255,230,197,1) 100%)"}
                    baseBgColor={"rgba(255,255,255,0.2)"}
                    labelColor={progressLabelColor}
                    className="screen-progress-bar"
                />

                <div style={{marginTop:"2vh"}}>
                    <span style={{
                        color:'#FFF',
                        fontSize: "4vh",
                        textTransform:"uppercase",
                    }}>{!bonus && "OBJECTIF"} {bonus && "NOUVEL OBJECTIF"} : {formater.format(campagneData.objectif)} {donorName}</span>
                </div>

            </div>

 */
